module.exports = __webpack_public_path__ + "img/org-dark.d6769f78.svg";